import { linko } from "@shared/linko";

export type CommunityAgeBucketKey =
  | "under18"
  | "18_24"
  | "25_34"
  | "35_44"
  | "45_54"
  | "55_64"
  | "65plus";

export interface CommunityAgeGenderRow {
  bucketKey: CommunityAgeBucketKey;
  bucketLabel: string;
  gender: string;
  count: number;
}

export interface CommunityMonthPoint {
  monthKey: string;
  label: string;
  count: number;
}

export interface CommunityNamedCount {
  name: string;
  count: number;
}

export interface CommunityEngagement {
  activeLast90Days: number;
  volunteeredEarlier: number;
  neverVolunteered: number;
}

export interface CommunityDashboardResult {
  community: {
    id: string;
    name: string;
    description: string | null;
  };
  memberCount: number;
  approvedParticipationsCount: number;
  newMembersLast30Days: number;
  activeMembersLast90Days: number;
  activeMembersPercent: number;
  reportedHours: number;
  joinsByMonth: CommunityMonthPoint[];
  participationsByMonth: CommunityMonthPoint[];
  topSubcategories: CommunityNamedCount[];
  engagement: CommunityEngagement;
  ageGender: CommunityAgeGenderRow[];
}

export interface CommunityMemberActivity {
  associationId: string;
  approvedParticipationsCount: number;
  lastParticipationAt: string | null;
  reportedHours: number;
}

type CommunityQueries = {
  getCommunityDashboard: (params: {
    communityId: string;
    organizationId: string;
  }) => Promise<{ data: CommunityDashboardResult }>;
  getCommunityMemberActivity: (params: {
    communityId: string;
    organizationId: string;
    associationIds: string[];
  }) => Promise<{ data: CommunityMemberActivity[] }>;
};

function communityQueries() {
  return linko.community.queries as unknown as CommunityQueries;
}

export async function fetchCommunityDashboard(params: {
  communityId: string;
  organizationId: string;
}): Promise<CommunityDashboardResult> {
  const { data } = await communityQueries().getCommunityDashboard(params);
  return data;
}

export async function fetchCommunityMemberActivity(params: {
  communityId: string;
  organizationId: string;
  associationIds: string[];
}): Promise<CommunityMemberActivity[]> {
  if (params.associationIds.length === 0) return [];
  const { data } = await communityQueries().getCommunityMemberActivity(params);
  return data;
}
